export const mapingFirebaseAuthError = (err) => {
  if (err.code === 'auth/user-disabled') {
    return 'ユーザーが無効になってます。'
  }
  return 'エラーが発生しました'
}
